import type { ReactNode } from "react";
import { useAuthStore } from "@/store/authStore";
import { ROLE_LABEL } from "@/services/types/auth";

export function HomeShell({ subtitle, actions, children }: { subtitle?: string; actions?: ReactNode; children: ReactNode }) {
  const user = useAuthStore((s) => s.user);
  const today = new Date();
  const dateStr = today.toLocaleDateString("zh-CN", {
    year: "numeric",
    month: "long",
    day: "numeric",
    weekday: "long",
  });
  return (
    <div className="flex flex-col gap-5 p-6 lg:p-8">
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div className="flex flex-col gap-1">
          <h1 className="text-2xl font-bold text-slate-900">
            早上好，{user?.name ?? "访客"}
          </h1>
          <span className="text-[13px] text-slate-500">
            {dateStr} · {user ? ROLE_LABEL[user.role] : ""}
            {subtitle ? ` · ${subtitle}` : ""}
          </span>
        </div>
        {actions && <div className="flex gap-2.5">{actions}</div>}
      </div>
      {children}
    </div>
  );
}
